import { useEffect, useState } from "react";
import "../../styles/ViewedUsers.css";

// ✅ FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faSave,
  faTimes
} from "@fortawesome/free-solid-svg-icons";

const ViewedUsers = ({ jobReqId }) => {
  const [data, setData] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedFeedback, setEditedFeedback] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    // ✅ Decode token
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        setUser(payload);
      } catch (err) {
        console.error("Invalid token");
      }
    }

    fetchViews();
  }, [jobReqId]);

  const fetchViews = async () => {
    const token = localStorage.getItem("token");

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/job-views/${jobReqId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const result = await res.json();
    if (result.success) {
      setData(result.data);
    }
  };

  // ✏️ Edit click
  const handleEdit = (index, currentFeedback) => {
    setEditingIndex(index);
    setEditedFeedback(currentFeedback || "");
  };

  // 💾 Save
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/job-feedback`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          jobReqId,
          feedback: editedFeedback
        })
      }
    );

    const result = await res.json();

    if (result.success) {
      await fetchViews(); // ✅ RELOAD DATA (IMPORTANT)

      setEditingIndex(null);
      setEditedFeedback("");
    } else {
      alert(result.message);
    }
  };
  return (
    <div className="viewed-users-container">

      <div className="viewed-users-table-wrapper">
        <table className="viewed-users-table">
          <thead>
            <tr>
              <th>Branch</th>
              <th>Employee</th>
              <th>Contact Num</th>
              <th>Feedback</th>
              <th>Viewed At</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((item, i) => {
                const isOwn = user?.emp_id === item.emp_id;

                return (
                  <tr key={i} className={isOwn ? "highlight-row" : ""}>
                              <td>
                      {(() => {
                        let branches = [];

                        if (Array.isArray(item.branch)) {
                          branches = item.branch;
                        } else if (typeof item.branch === "string") {
                          branches = item.branch.split(",");
                        }

                        const firstBranch = branches[0]?.trim();
                        const fullText = branches.map(b => b.trim()).join(", ");

                        return (
                          <span className="branch-cell" title={fullText}>
                            {branches.length > 1 ? `${firstBranch}...` : firstBranch || "-"}
                          </span>
                        );
                      })()}
                    </td>

                    <td>{item.emp_name}</td>
                    <td>{item.contact_num}</td>

                    {/* Feedback */}
                    <td>
                      {editingIndex === i ? (
                        <input
                          className="feedback-input"
                          value={editedFeedback}
                          onChange={(e) =>
                            setEditedFeedback(e.target.value)
                          }
                        />
                      ) : item.emp_feedback ? (
                        item.emp_feedback
                      ) : (
                        <span className="no-feedback">No feedback</span>
                      )}
                    </td>

                    <td>
                      {new Date(item.viewedAt).toLocaleString("en-IN")}
                    </td>

                    {/* Actions */}
                    <td>
                      {isOwn && (
                        editingIndex === i ? (
                          <div className="action-group">
                            <button
                              className="action-btn save"
                              onClick={handleSave}
                            >
                              <FontAwesomeIcon icon={faSave} />
                            </button>

                            <button
                              className="action-btn cancel"
                              onClick={() => setEditingIndex(null)}
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                          </div>
                        ) : (
                          <button
                            className="action-btn edit"
                            onClick={() => handleEdit(i, item.emp_feedback)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                        )
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                  No users have viewed this job yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewedUsers;